// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K3aZM","colBig":"styles_colBig__1XJVY","colSmall":"styles_colSmall__1lezW","shopifyNameWrapper":"styles_shopifyNameWrapper__6iVjA"};